import React, { useEffect, useState } from "react";
import SearchComponent from "../../components/SearchComponent";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../../utils/ApiService";
import { Avatar, formatDateTime } from "../../common/Functions";
import { showToast } from "../../common/Toast";
import Pagination from "../../common/Pagination";
import EventDetailPage from "../EventDetail";
import Swal from "sweetalert2";
import FullPageLoader from "../../common/FullPageLoader";
import { capitalizeEachWord } from "../../utils/common";

function EventManagement() {
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const limit = 10;
  const [search, setSearch] = useState("");
  const [selectedEvent, setSelectedEvent] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getEvents(page, limit);
  }, []);
  const getEvents = async (currentPage, currentLimit, search) => {
    const params = {
      page: currentPage,
      limit: currentLimit,
    };
    if (search) {
      params.keyword = search;
    }
    try {
      setLoading(true);
      const queryString = new URLSearchParams(params).toString();
      const res = await ApiService.get(`admin/event-list?${queryString}`);
      if (res.success) {
        setEvents(res.events);
        setPagination(res.pagination);
        console.log(res);
      }
    } catch (error) {
      console.log("event error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this event?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(139 115 89)",
      // cancelButtonColor: '#d33',
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const res = await ApiService.post(`admin/delete-event`, { eventId: id });
      if (res.success) {
        showToast.success("Event deleted successfully");
        getEvents();
      }
    });
  };

  const handlePagination = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPage(newPage);
      getEvents(newPage, limit, search);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.startsWith(" ")) return;
    setSearch(value);
    setPage(1);
    getEvents(1, limit, e.target.value);
  };

  const handleStatus = async (id, status) => {
    try {
      let params = {
        eventId: id,
        enableStatus: !status,
      };
      const res = await ApiService.post(`/admin/enable-disable-event`, params);
      console.log(res);
      if (res.success) {
        showToast.success(res?.message);
        getEvents(page, limit);
      } else {
        showToast.error(res.message);
      }
    } catch (error) {
      console.log("hanle status error", error);
    }
  };
  return (
    <>
      {loading && <FullPageLoader />}
      <div className="flex-grow bg-gray-100  px-6 pb-2 w-full overflow-auto h-[90vh]">
        <div className="w-full">
          {!selectedEvent?._id && 
            <div className="mb-6">
              <SearchComponent
                search={search}
                onChange={handleSearch}
                placeholder={"Search by event name..."}
              />
            </div>
          }
          {selectedEvent?._id ? (
            <EventDetailPage
              eventId={selectedEvent?._id}
              selectedEvent={selectedEvent}
              setSelectedEvent={setSelectedEvent}
            />
          ) : (
            <>
              <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
                <table className="w-full text-center">
                  <thead className="bg-gray-200 text-m text-black">
                    <tr>
                      <th className="p-4 text-left font-normal">Event Id</th>
                      <th className="p-4 text-left font-normal">Date & Time</th>
                      <th className="p-4 text-left font-normal">Host Name</th>
                      <th className="p-4 text-left font-normal">Event Name</th>
                      <th className="p-4 text-left font-normal">Total Interested</th>
                      <th className="p-4 text-left font-normal">Total Engagement</th>
                      <th className="p-4 text-left font-normal">Total Booking</th>
                      <th className="p-4 text-centre font-normal">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((event, index) => (
                      <tr
                        key={event?._id}
                        className="border-t hover:bg-gray-50 cursor-pointer"
                      >
                        <td
                          className="p-4 text-left underline cursor-pointer font-normal text-[#4C4C4C] text-sm"
                          onClick={() => setSelectedEvent(event)}
                        >
                          #{event?._id?.slice(-6)}
                        </td>
                        <td className="p-4 text-left font-normal text-[#4C4C4C] text-sm">
                          {formatDateTime(event?.startTime)}
                        </td>
                        <td className="flex p-4 text-left font-normal text-[#4C4C4C] text-sm items-center gap-2 ">
                          <Avatar
                            name={event?.host?.name}
                            image={event?.host?.image}
                          />
                          {capitalizeEachWord(event?.host?.name) || "-"}
                        </td>
                        <td className="p-4 text-left font-normal text-[#4C4C4C] text-sm">
                          <span>{event.name || "N/A"}</span>
                        </td>
                        <td className="p-4 text-left font-normal text-[#4C4C4C] text-sm">
                          {event.interestedCount || "-"}
                        </td>
                        <td className="p-4 text-left font-normal text-[#4C4C4C] text-sm">
                          <span>{event.engagementCount || "-"}</span>
                        </td>
                        <td className="p-4 text-left font-normal text-[#4C4C4C] text-sm">
                          {event.bookingCount || "-"}
                        </td>
                        <td className="p-4 text-center align-middle">
                          <button 
                          disabled={event?.bookingCount > 0}
                            onClick={() =>
                              handleStatus(event._id, event.enableStatus)
                            }
                            className={`relative inline-block w-8 h-4 rounded-full transition ${
                              event.enableStatus ? "bg-green-500" : "bg-gray-300" 
                            } ${event?.bookingCount > 0 && " opacity-50 cursor-not-allowed"}`}
                          >
                            <span
                              className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition ${
                                event.enableStatus ? "translate-x-4" : ""
                              }`}
                            />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {
                pagination.totalPages > 1 && (
                  <Pagination
                    page={page}
                    totalPages={pagination.totalPages}
                    totalItems={pagination.totalEvent}
                    limit={limit}
                    onPageChange={(newPage) => handlePagination(newPage)}
                  />
                )
              }
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default EventManagement;
